<script>
	const utilities = require('utilities');
	const printable = require('mixins/printable');
	const analyticsUtilities = require('utilities/analyticsUtilities');

	const fireEvent = analyticsUtilities.fireEvent;
	const PRINT = analyticsUtilities.events.PRINT;
	/**
	 * This is a modal that displays a vocabulary image
	 */
	module.exports = {
		mixins: [printable],
		components: {
			modal: require('./modal.vue').default
		},
		modelData: ['activeProduct'],
		data: function () {
			return {
				imageInfo: null,
				article: null,
				word: null
			};
		},
		mounted() {
			this.$subscribe('modal-opened', (id, opts) => {
				if (id !== 'vocabulary-image-modal') {
					return true; // let some other handler take this
				}

				this.imageInfo = opts.imageInfo;
				this.word = opts.word;

				return false;
			});

			this.$subscribe('modal-closed', id => {
				if (id !== 'vocabulary-image-modal') {
					return true; // let some other handler take this
				}
				this.imageInfo = null;
				this.word = null;
				return false;
			});
		},
		methods: {
			printThis: function () {
				if (!this.imageInfo) {
					return;
				}

				fireEvent(PRINT, {
					pid: this.activeProduct.uuid,
					section: 'vocabulary',
					isImage: true
				});

				let filename = 'ReadWorks Vocabulary - ' + this.word;
				let target = '.vocab-image-print-container';
				let footer = '<div>ReadWorks.org · © 2017 ReadWorks®, Inc. All rights reserved.</div>';
				let documentHeader = '';
				let header = filename;

				if (this.imageInfo.credit) {
					footer = '<div>Credit: ' + this.activeImage.credit + '</div>' + footer;
				}

				this.print(target, {
					filename: filename,
					header: header,
					documentHeader: documentHeader,
					footer: footer
				});
			},
			close() {
				utilities.closeModals();
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	#vocabulary-image-modal {
		.modal-content {
			padding: 1rem;
		}
		.modal-window-wrap {
			max-width: 750px;
		}
		.print-button {
			line-height: 1.5rem;
			float: right;
			margin-top: 0.5rem;
			.fa-print {
				color: $c-white;
				cursor: pointer;
				font-size: 1.5rem;
				&:hover {
					color: $c-slate-light;
				}
			}
		}
		.attribution {
			padding: 0.1rem 0.25rem;
			margin-top: 0.5rem;
		}

		.vocab-image-print-container {
			width: 100%;
			height: 100%;
			text-align: center;
			> div:first-child {
				height: 0;
			}
			.vocab-image {
				display: block;
				margin: 0 auto;
			}
		}
	}

	// Student styling
	.route-student-workspace {
		#vocabulary-image-modal {
			.modal-window {
				padding-top: 7rem;
			}
			.print-button {
				display: none;
			}
		}
	}
</style>
<template>
	<modal id="vocabulary-image-modal">
		<div slot="top-tools">
			<button
				class="modal-close"
				v-on:click.prevent="close"
				aria-label="Close modal">
				<span aria-hidden="true">&times;</span>
			</button>
			<span class="print-button">
				<i
					@click="printThis()"
					class="fa-solid fa-print fa-3"
					aria-label="Print"></i>
			</span>
		</div>
		<div slot="content">
			<template v-if="imageInfo">
				<div class="vocab-image-print-container">
					<div>&nbsp;</div>
					<img
						class="vocab-image"
						:src="imageInfo.url"
						:alt="imageInfo.alt" />
				</div>
				<div
					v-if="imageInfo.credit"
					class="attribution">
					Credit: {{ imageInfo.credit }}
				</div>
			</template>
		</div>
	</modal>
</template>
